import { isoDate } from '../../utils/format';

export const DEFAULT_RANGE = '28d';

export const RANGE_OPTIONS = [
  { value: '7d', label: 'Last 7 days' },
  { value: '14d', label: 'Last 14 days' },
  { value: '28d', label: 'Last 28 days' },
  { value: '90d', label: 'Last 90 days' },
  { value: 'this_month', label: 'This month' },
  { value: 'last_month', label: 'Last month' },
  { value: 'custom', label: 'Custom range' },
];

/**
 * { since, until } (YYYY-MM-DD) of a query's range: a preset, or since / until when custom
 */
export function resolveRange({ range = DEFAULT_RANGE, since, until }) {
  const today = new Date();
  const daysAgo = (days) => new Date(today.getFullYear(), today.getMonth(), today.getDate() - days);
  switch (range) {
    case 'custom':
      return { since: since || isoDate(daysAgo(27)), until: until || isoDate(today) };
    case 'this_month':
      return { since: isoDate(new Date(today.getFullYear(), today.getMonth(), 1)), until: isoDate(today) };
    case 'last_month':
      return {
        since: isoDate(new Date(today.getFullYear(), today.getMonth() - 1, 1)),
        until: isoDate(new Date(today.getFullYear(), today.getMonth(), 0)),
      };
    default: {
      const days = parseInt(range, 10) || 28;
      return { since: isoDate(daysAgo(days - 1)), until: isoDate(today) };
    }
  }
}
